/**
 * AbilityTransformToStone.js
 * Implements the 'Transform Bubbles to Stone' enemy ability
 */

import { Game, GameTimer } from "pixi_core";

import { Ability } from "./Ability";
import { Common } from "../Common";
import { Bubble } from "../Bubble";

import { shuffle, BubbleColor, ENEMY_ABILITY_PARTICLE_TRAVEL_TIME } from "../../Constants";

export class AbilityTransformToStone extends Ability {
    /**
     * @public
     * @param {Number} nbBubbles
     * @param {{x: Number, y: Number}} startPos
     * @param {Function} callback
     */
    constructor(nbBubbles, startPos, callback) {
        super();

        /** @private @type {Bubble[]} */
        this._bubbles = [];

        // TODO: It seems stone bubbles may be returned here, investigate
        let coloredBubbles = Common.grid.getColoredBubbles(true);

        if (coloredBubbles.length > 0) {
            coloredBubbles = shuffle(coloredBubbles);

            for (let i = 0; i < coloredBubbles.length; ++i) {
                if (i < nbBubbles) {
                    const bubble = coloredBubbles[i];
                    this._bubbles.push(bubble);

                    if (startPos) {
                        Common.particles.createEnemyAbilityParticle(startPos.x, startPos.y, bubble.x, bubble.y, null);
                    }
                } else {
                    break;
                }
            }
        }

        // Spawn bubble instantly if there is no start position (and no particle)
        const delay = startPos && this._bubbles.length > 0 ? ENEMY_ABILITY_PARTICLE_TRAVEL_TIME : 0;

        /** @private @type {GameTimer} */
        this._timerParticlesDelay = Game.windows.getCurrentWindow().createTimer(delay);
        this._timerParticlesDelay.onComplete = () => {
            if (this._bubbles) {
                for (const bubble of this._bubbles) {
                    bubble.changeColor(
                        {
                            color: BubbleColor.eSTONE,
                            special: BubbleColor.eNONE
                        },
                        true
                    );
                }
            }

            if (callback) {
                callback();
            }
        };
    }

    /**
     * @public
     */
    destroy() {
        if (this._timerParticlesDelay) {
            this._timerParticlesDelay.destroy();
            this._timerParticlesDelay = null;
        }

        this._bubbles = null;
    }
}
